<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4AmfkT/tc-custom/9781439678374.jpg?1704886584281" alt="This image is the cover for the book Monticello, Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monticello, Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <p>The 1872 French castle courthouse set the tone for construction in Monticello. Numerous elegant churches, residences, schools, and civic buildings followed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Spencer, Rebecca Spencer
      </h2>
      
      <p class="authorDescription body article">Authors Mark and Rebecca Spencer have long appreciated the significance of Monticello's various architectural designs that reflect the people, values, and culture of the community. Mark is the award-winning author of several books, and Rebecca is an award-winning photographer and owner/operator of the Nightmare Maze, a popular Halloween attraction at the famously haunted Allen House.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8978f35c